import { render, staticRenderFns } from "./Details2ProductDesktop.vue?vue&type=template&id=88897c76&scoped=true"
import script from "./Details2ProductDesktop.vue?vue&type=script&lang=js"
export * from "./Details2ProductDesktop.vue?vue&type=script&lang=js"
import style0 from "./Details2ProductDesktop.vue?vue&type=style&index=0&id=88897c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88897c76",
  null
  
)

export default component.exports